import { z } from "zod";

/** Physiotherapy session (rehab progress tracking). */

const dateStr = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

export const physioSessionApiSchema = z.object({
	id: z.string().uuid(),
	clinic_id: z.string().uuid(),
	patient_id: z.string().uuid(),
	visit_id: z.string().uuid().nullable(),
	session_date: dateStr,
	pain_score: z.number().int().nullable(),
	body_region: z.string().nullable(),
	interventions: z.string().nullable(),
	rom_notes: z.string().nullable(),
	progress_note: z.string().nullable(),
	recorded_by_member_id: z.string().uuid().nullable(),
	created_at: z.string().datetime(),
});
export type PhysioSessionApi = z.infer<typeof physioSessionApiSchema>;

export const createPhysioSessionInputSchema = z.object({
	patient_id: z.string().uuid(),
	visit_id: z.string().uuid().optional(),
	session_date: dateStr,
	pain_score: z.coerce.number().int().min(0).max(10).nullable().optional(),
	body_region: z.string().max(200).nullable().optional(),
	interventions: z.string().max(2000).nullable().optional(),
	rom_notes: z.string().max(2000).nullable().optional(),
	progress_note: z.string().max(2000).nullable().optional(),
});
export type CreatePhysioSessionInput = z.infer<
	typeof createPhysioSessionInputSchema
>;
